// extracted by mini-css-extract-plugin
export default {"quote":"Quote_quote__IQHUU","author-portrait":"Quote_author-portrait__2wsX9","text":"Quote_text__8Sj8P","author":"Quote_author__p1w7C"};